import { Bank } from '@/api/dictionary';
import { actionCreator } from '@/utils/redux';

import { InvoiceDetailsLoadError, InvoiceDetails, Limits, NAMESPACE } from './types';

const creator = actionCreator(NAMESPACE);

export interface StoreInitActionPayload {
  banks?: Bank[];
  limits?: Limits;
  details?: InvoiceDetails;
}

export interface StoreInvoiceActionPayload {
  details?: InvoiceDetails;
  error?: InvoiceDetailsLoadError;
}

// sagas
export const init = creator.asyncAction<void>('INIT');
export const createInvoice = creator.asyncAction<void>('CREATE');

// reducers
export const storeInitialized = creator.syncActionWithPayload<StoreInitActionPayload>('STORE_INIT');
export const storeInvoice = creator.syncActionWithPayload<StoreInvoiceActionPayload>('STORE_INVOICE');
export const storeStatus = creator.syncAction('STORE_REFRESH_STATUS');
export const storeLogout = creator.syncAction('STORE_LOGOUT');

// notifications
export const notifyInitializationFinished = creator.syncAction('INIT_FINISHED');

export default {
  init,
  createInvoice,
  storeInitialized,
  storeInvoice,
  storeStatus,
  storeLogout,
  notifyInitializationFinished,
};
